import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";

import LocalizationConstants from "../constants/localization-constants";

@Injectable()
export class WimtMatPaginatorIntl implements MatPaginatorIntl {
  constructor(private translate: TranslateService) {}
  changes = new Subject<void>();

  firstPageLabel = this.translate.instant(LocalizationConstants.PAGINATION_FIRST_PAGE);
  itemsPerPageLabel = this.translate.instant(LocalizationConstants.PAGINATION_ITEMS_PER_PAGE);
  lastPageLabel = this.translate.instant(LocalizationConstants.PAGINATION_LAST_PAGE);

  nextPageLabel = this.translate.instant(LocalizationConstants.PAGINATION_NEXT_PAGE);
  previousPageLabel = this.translate.instant(LocalizationConstants.PAGINATION_PREVIOUS_PAGE);

  getRangeLabel(page: number, pageSize: number, length: number): string {
    const amountPages = Math.ceil(length / pageSize);
    return (
      this.translate.instant(LocalizationConstants.PAGINATION_PAGE, {
        current: length === 0 ? 1 : page + 1,
        last: amountPages === 0 ? 1 : amountPages,
      }) + ` (${length} ${this.translate.instant(LocalizationConstants.PAGINATION_RESULTS)})`
    );
  }
}
